import { render } from "./SessionWorkflowActions.vue?vue&type=template&id=70e85811"
import script from "./SessionWorkflowActions.vue?vue&type=script&lang=js"
export * from "./SessionWorkflowActions.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__